// extracted by mini-css-extract-plugin
module.exports = {"videoSection":"PhoneVideo_videoSection___i0UT","videoWrapper":"PhoneVideo_videoWrapper__a7SEE","video":"PhoneVideo_video__O6i7R"};